import { Component, NodeEventType, warn, _decorator } from 'cc';

const { ccclass } = _decorator;

const eventTypes = { ...NodeEventType };

/**
 * 盡量搭配 Node 以外的 Component 使用，如 Button。
 */
@ccclass('BlockDragableEvent')
export default class BlockDragableEvent extends Component {
    protected start(): void {
        let isEventExist = false;
        Object.values(eventTypes).forEach((event) => {
            if (!isEventExist) {
                isEventExist = this.node.hasEventListener(event);
            }
        });
        if (!isEventExist) {
            warn(`BlockDragableEvent: No event listener found on node ${this.node.name}.`);
        }
    }
}
